import React, { useEffect, useMemo } from 'react'
import { TextInput } from '@/components'
import { t } from '@/i18n'
import useMonthlyPrice from '@/pages/Proposal/useMonthlyPrice'
import { useApp } from '@/hooks'
import { IProposal } from '@/types'

interface Props {
  emptyValue?: string | null
  getValues: any
  watch: any
  isEditing?: boolean
  children?: React.ReactNode
  initialData?: Partial<IProposal>
  onTriggerChange: (name: string, value: any) => void

  [x: string]: any
}

const ProposalPriceFormComponents: React.FC<Props> = ({
  emptyValue,
  getValues,
  watch,
  isEditing,
  initialData,
  onTriggerChange,
  ...props
}) => {
  const monthlyPrice = useMonthlyPrice(getValues, watch)

  const { generalSettings } = useApp()

  useEffect(() => {
    if (!initialData?.id) {
      const baseIndex = getValues('baseIndex')
      onTriggerChange('baseIndex', baseIndex ?? generalSettings?.index)
    }
  }, [generalSettings?.index, getValues, initialData, onTriggerChange])

  const rest = useMemo(
    () => ({ ...props, isEditing, disabled: !isEditing, emptyValue }),
    [props, isEditing, emptyValue],
  )

  return (
    <>
      <TextInput
        {...rest}
        isCurrency
        name="monthlyPayment"
        type="number"
        value={monthlyPrice}
        disabled
        label={t('monthly_payment')}
      />
      <TextInput
        {...rest}
        required
        name="baseIndex"
        type={'number'}
        label={t('base_index')}
      />
      <TextInput
        {...rest}
        isCurrency
        name="deposit"
        type="number"
        label={t('deposit')}
      />
      <TextInput
        {...rest}
        isCurrency
        name="securityDeposit"
        type="number"
        label={t('securityDeposit')}
      />
      <TextInput
        {...rest}
        isCurrency
        required
        name="carPrice"
        type="number"
        label={t('car_price')}
        min={0}
      />
      <TextInput
        {...rest}
        isCurrency
        name="servicePrice"
        type="number"
        label={t('service_price')}
      />
      <TextInput
        {...rest}
        isCurrency
        name="totalPrice"
        type="number"
        label={t('total_price')}
      />
      <TextInput
        isCurrency
        {...rest}
        name="participationFee"
        type="number"
        label={t('participation_fee')}
      />
      <TextInput
        isCurrency
        {...rest}
        required
        name="residualPrice"
        type="number"
        label={t('residual_price')}
      />
      <TextInput
        isCurrency
        {...rest}
        name="comprehensiveInsurancePrice"
        type="number"
        label={t('comprehensive_insurance_price')}
      />
      <TextInput
        {...rest}
        isCurrency
        name="comprehensiveInsuranceYoungPrice"
        type="number"
        label={t('comprehensive_insurance_young_price')}
      />
      <TextInput
        {...rest}
        isCurrency
        name="compulsoryInsurancePrice"
        type="number"
        label={t('compulsory_insurance_price')}
      />
      <TextInput
        {...rest}
        isCurrency
        name="licencePrice"
        type="number"
        label={t('licence_price')}
      />
      <TextInput
        {...rest}
        isCurrency
        name="trackingMonthlyRate"
        type="number"
        label={t('trackingMonthlyRate')}
      />
    </>
  )
}

export default ProposalPriceFormComponents
